export const INITIALIZE_SEGMENTS = 'INITIALIZE_SEGMENTS';
export const GET_SEGMENTS_LIST = 'GET_SEGMENTS_LIST';
export const GET_DISTANCE = 'GET_DISTANCE';
export const DELETE_SEGMENT = 'DELETE_SEGMENT';
export const GET_TOTAL_SEGMENTS = 'GET_TOTAL_SEGMENTS';
